<template>
  <div class="order-list">
    <van-nav-bar title="用户管理" left-text="返回" left-arrow @click-left="$router.push('/user')" >
      <template #right>
        <van-dropdown-menu active-color="#1989fa" >
          <van-dropdown-item v-model="userType" :options="userTypeOption" @change="filterOrder"/>
        </van-dropdown-menu>
      </template>
    </van-nav-bar>
    <form action="/">
      <van-search
              v-model="keyword"
              show-action
              placeholder="请输入搜索关键词"
              @search="onSearch"
              @cancel="onCancel"
      />
      <van-tabs v-model="sortBy" @click="changeSort" id="sortBar">
        <van-tab><template #title> 加入时间 <van-icon :name="orderType == 'desc'? 'arrow-down': 'arrow-up'" v-show="sortBy == 0" /></template></van-tab>
        <van-tab><template #title> 团队人数 <van-icon :name="orderType == 'desc'? 'arrow-down': 'arrow-up'" v-show="sortBy == 1"/></template></van-tab>
        <van-tab><template #title> 个人收入 <van-icon :name="orderType == 'desc'? 'arrow-down': 'arrow-up'" v-show="sortBy == 2"/></template></van-tab>
        <van-tab><template #title> 团队收入 <van-icon :name="orderType == 'desc'? 'arrow-down': 'arrow-up'" v-show="sortBy == 3"/></template></van-tab>
      </van-tabs>
      <van-tabs v-model="active" @click="pushRefresh">
        <van-tab v-for="index in 7" :key="index">
          <template #title>{{tab[index-1]}}<font color="red">({{userCounts[index-1]}})</font></template>
        </van-tab>
      </van-tabs>
    </form>


    <div style="margin-top:10px">
      <van-pull-refresh v-model="refreshing" @refresh="pushRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getUser">
          <van-collapse v-model="activeNames" v-for="item in userList"
                        :key="item.wechatOpenid" >
            <van-collapse-item :name="item.id" :ref="`item_`+item.id">
              <template #title>
                <div @click="clickItem(item.id, item.wechatOpenid)">{{item.nickName}}( {{userLevel(item.userType, item.shareLevel)}})</div>
                <div @click="clickItem(item.id, item.wechatOpenid)" style="float: left">
                  <van-tag :type="`${item.isEnable === '1'?'success':'primary'}`" v-show="item.userType != '3'">{{item.isEnable === '1'?'已激活':'未激活'}}</van-tag>
                </div>
                <van-cell @click="clickItem(item.id, item.wechatOpenid)" :title="`加入时间:`+item.accessTime"
                          title-class="custom-title" value-class="custom-value"
                />
                <van-cell @click="clickItem(item.id, item.wechatOpenid)" :title="`直接分享:`+item.shareUser"
                          title-class="custom-title" value-class="custom-value"
                />
                <van-cell @click="clickItem(item.id, item.wechatOpenid)" :title="`激活时间:`+item.upgradeTime"
                          :value="`激活方式:`+item.upgradeType == '2'?'分享':'手动'"
                          title-class="custom-title" value-class="custom-value" v-show="item.isEnable === '1'"
                />
                <van-cell @click="clickItem(item.id, item.wechatOpenid)" :title="`已赚:`+formatPrice(item.totalMoney)" :value="`可提现:`+formatPrice(item.money)"
                          title-class="custom-title" value-class="custom-value"  v-show="item.userType != '3' && item.isEnable === '1' "
                />
                <van-cell @click="clickItem(item.id, item.wechatOpenid)" :title="`团队人数:`+item.team" :value="`团队收入:`+formatPrice(item.teamIncome)"
                          title-class="custom-title" value-class="custom-value"
                />
              </template>
              <van-cell-group v-for="son in fetchSonUser(item.id)"
                              :key="son.id">
                <van-cell :title="son.nickName+`(`+userLevel(son.userType, son.shareLevel)+`)`"
                          :value="`收入:`+formatPrice(son.totalMoney) + `  可提现:`+formatPrice(son.money)"
                          :label="son.isEnable === '1'?'已激活':'未激活'"
                          title-class="custom-title" value-class="custom-value"/>
                <van-cell :title="` 加入时间:`+son.accessTime"
                          :value="` 队伍:`+son.team"
                          title-class="join-custom-title" value-class="join-custom-value"
                />
                <van-cell :title="` 激活时间:`+son.upgradeTime"
                          :value="` 激活方式:`+upgradeTypeName(son.upgradeType)"
                          title-class="active-custom-title" value-class="active-custom-value" v-show="son.isEnable === '1'"
                />
              </van-cell-group>
            </van-collapse-item>

          </van-collapse>
        </van-list>
      </van-pull-refresh>
      <no-data v-if="userList.length == 0 && !loading"></no-data>
    </div>
  </div>
</template>


<script>
    import { Icon, Cell, CellGroup, NavBar, Button, Card, Tag ,Tab, Tabs, Panel, PullRefresh,DropdownMenu,DropdownItem, Collapse, CollapseItem, Search} from "vant";
    import NoData from "@/components/NoData";
    import fetch from '../../libs/fetch'
    import {Dialog} from 'vant'
    export default {
        components: {
            [NavBar.name]: NavBar,
            [Icon.name]: Icon,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Button.name]: Button,
            [Card.name]: Card,
            [Tag.name]: Tag,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Panel.name]: Panel,
            [PullRefresh.name]: PullRefresh,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [Search.name]: Search,

            NoData
        },
        data() {
            return {
                loading: false,
                finished: false,
                refreshing: false,
                userList: [],
                tab:[
                   '所有',
                    '上月',
                    '本月',
                    '上周',
                    '本周',
                    '昨天',
                    '今天',
                ],
                page: {
                    pageNum: 1,
                    pageSize: 20
                },
                sortBy: 0,
                bakSortBy: 0,
                orderType: 'desc',
                keyword: '',
                active: 6,
                userCounts: [0,0,0,0,0,0,0],
                userType: '',
                userTypeOption: [
                    { text: '所有', value: '' }
                ],

                activeNames: [],
                sonuserInfo:[],
                userInfo:{

                },
            };
        },
        mounted() {
            const openid = localStorage.getItem('openId')
            let url = '/pdd-user/public/mp/user?openId=' + openid;
            fetch({
                url: url,
                method: 'get'
            }).then(response => {
                this.userInfo = response.data;
                if(this.userInfo.shareLevel == -1){
                   this.userTypeOption.push({ text: 'A级', value: '2' })
                   this.userTypeOption.push({ text: 'B级', value: '3' })
                   this.userTypeOption.push({ text: 'C级', value: '4' })
                   this.userTypeOption.push({ text: '用户', value: '5' })
                }else if(this.userInfo.shareLevel == 0){
                    this.userTypeOption.push({ text: 'B级', value: '3' })
                    this.userTypeOption.push({ text: 'C级', value: '4' })
                    this.userTypeOption.push({ text: '用户', value: '5' })
                }else if(this.userInfo.shareLevel == 1){
                    this.userTypeOption.push({ text: '下级', value: '4' })
                    this.userTypeOption.push({ text: '用户', value: '5' })
                }else if(this.userInfo.shareLevel == 2){
                    this.userTypeOption.push({ text: '用户', value: '5' })
                }
            }).catch(error => {
                console.log(error)
                Dialog.alert({
                    title: '系统提示',
                    message: error
                }).then(() => {
                    // on close
                })
            });
        },
        computed: {},
        methods: {
            pushRefresh() {
                this.loading = true
                this.userList = []
                this.page.pageNum = 1
                this.getUser()
                this.finished = false
            },
            getUserCounts() {
                for (var i=0;i<7;i++){
                    this.getUserCount(i)
                }
            },
            getUserCount(periodType) {
                // 获取用户信息
                const openid = localStorage.getItem('openId')
                const appId = localStorage.getItem('appId')
                let url = '/pdd-user/public/agent/'+openid+'/users?appkey=' + appId+"&periodType="+periodType+"&pageSize="+
                    this.page.pageSize+"&pageNum=1"+"&userType="+this.userType+'&sortBy='+this.sortBy+'&orderType='+this.orderType+'&keyword='+this.keyword;
                fetch({
                    url: url,
                    method: 'get'
                }).then(response => {
                    this.userCounts[periodType] = response.data.total
                }).catch(error => {
                    console.log(error)
                    Dialog.alert({
                        title: '系统提示',
                        message: error
                    }).then(() => {
                        // on close
                    })
                });
            },
            getUser() {
                this.getUserCounts()
                // 获取用户信息
                const openid = localStorage.getItem('openId')
                const appId = localStorage.getItem('appId')
                let url = '/pdd-user/public/agent/'+openid+'/users?appkey=' + appId+"&periodType="+this.active+"&pageSize="+
                    this.page.pageSize+"&pageNum="+this.page.pageNum+"&userType="+this.userType+'&sortBy='+this.sortBy+'&orderType='+this.orderType+'&keyword='+this.keyword;

                fetch({
                    url: url,
                    method: 'get'
                }).then(response => {
                    let totalPage = Math.floor(response.data.total/this.page.pageSize) + 1
                    if(totalPage == this.page.pageNum){
                        this.finished = true
                    } else {
                        this.page.pageNum++
                    }
                    this.userList = this.userList.concat(response.data.list);
                    this.loading = false
                    this.refreshing = false
                }).catch(error => {
                    console.log(error)
                    Dialog.alert({
                        title: '系统提示',
                        message: error
                    }).then(() => {
                        // on close
                    })
                    this.loading = false
                    this.refreshing = false
                });
            },
            getDate(date_str) {
                return date_str.split(".")[0];
            },
            formatPrice(money) {
                if (money) {
                    let _money = Math.ceil(Number(money)) / 100;
                    return _money;
                } else {
                    return 0;
                }
            },
            userLevel(type, level){
                if(type == 0) {
                    return '管理员'
                }else if(type == 1){
                    return '团长'
                }else if(type == 2 && level == 0){
                    return 'A级'
                }else if(type == 2 && level == 1 && this.userInfo.shareLevel <= 0){
                    return 'B级'
                }else if(type == 2 && level == 2 && this.userInfo.shareLevel <= 0){
                    return 'C级'
                }else if(type == 2 && level == 1 && this.userInfo.shareLevel >  0){
                    return '代理'
                }else if(type == 2 && level == 2 && this.userInfo.shareLevel > 0){
                    return '代理'
                }else{
                    return '用户'
                }

            },

            changeSort(){
                if(this.sortBy != this.bakSortBy){
                    this.bakSortBy = this.sortBy
                }else{
                    if(this.orderType == 'desc'){
                        this.orderType = 'asc'
                    }else{
                        this.orderType = 'desc'
                    }
                }
                this.pushRefresh()
            },
            clickItem(id, openId){

                if(this.activeNames.indexOf(id) <0){
                    let url = '/pdd-user/public/agent/'+openId+'/sonuser'

                    fetch({
                        url: url,
                        method: 'get'
                    }).then(response => {
                        if(response.data.length > 0){
                            let sonUser = {id: id, userList: response.data};
                            this.sonuserInfo.push(sonUser)
                        }

                    }).catch(error => {
                        console.log(error)
                        Dialog.alert({
                            title: '系统提示',
                            message: error
                        }).then(() => {
                            // on close
                        })
                    });

                }

            },

            fetchSonUser(openId){
                for(let i = 0; i < this.sonuserInfo.length; i++){
                    if(this.sonuserInfo[i].id == openId){
                        return this.sonuserInfo[i].userList
                    }
                }
            },
            filterOrder(){
                this.pushRefresh()
            },

            onSearch(){
                this.pushRefresh()
            },
            onCancel(){
                this.keyword = ''
                this.pushRefresh()
            },
            upgradeTypeName(type){
                if(type == '1'){
                    return '手动'
                }else if(type == '2'){
                    return '分享'
                }else if(type == '3'){
                    return '升级'
                }else{
                    return ''
                }

            },
        },
        filters: {
            // formatPrice(money) {
            //   return money.toFix(2)
            // }
        }
    };
</script>

<style lang="less">
  .order-list {
    z-index: 1000;
    padding-bottom: 55px;
    background-color: #f8f8f8;
    p {
      margin: 0;
    }
  }
  .custom-title {
    font-size: 12px;
  }
  .custom-value{
    font-size: 10px;
  }
  .van-dropdown-menu__bar{
    box-shadow: none;
  }
  .van-tabs__line{
    z-index: 0;
  }
  .van-cell{
    padding-top: 5px;
    padding-bottom: 5px;

  }
  .join-custom-value{
    font-size: 10px;
    color: red;
  }
  .join-custom-title{
    font-size: 10px;
    color: red;
  }
  .active-custom-value{
    font-size: 10px;
    color: blue;
  }
  .active-custom-title{
    font-size: 10px;
    color: blue;
  }
</style>
